module.exports = __webpack_public_path__ + "static/1174972796.893ba026.jpg";